type InputProps = {
  name: string;
  label: string;
  rows?: number;
  placeholder?: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
};

export const TextArea: React.FC<InputProps> = ({
  name,
  label,
  rows = 4,
  placeholder,
  value,
  onChange,
}) => {
  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm/6 font-medium text-gray-900"
      >
        {label}
      </label>
      <div className="mt-2">
        <textarea
          id={name}
          name={name}
          rows={rows}
          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6"
          defaultValue={placeholder}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
